module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAALxJREFUOBHt1UEKxCAMAMCsLNhPFF/Xq76lvfqK/sjqI6oXu2TBUPYQLVjYQ3NpSnQMOejLOXfADfFGUynVld62DURX8YQ9MA3jP0YRY4QQAnXFJc0dIzrPM6zrynlUa4ILKoSAaZpoM5dU4TOqtQYpJedRrQrTyotJFR6GAYwxkHOGZVkgpdR0RBVG5Yxba5tgwNutNfZ9P7z31eVoNnVcWsTOx3Esv+z3EsxKP8UHpoHcNorvm4dvVO/4AJgSh50MWBC6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_prev_page.png
// module id = rJt7
// module chunks = 1